import React from 'react';

const Footer = () => (
  <footer className="py-6 bg-gray-800 text-white text-center text-sm">
    <p>&copy; {new Date().getFullYear()} Kolorowe Domki. Wszelkie prawa zastrzeżone.</p>
  </footer>
);

export default Footer;